import { ButtonType } from '../../Utilities/Enums/ButtonTypeEnum';
import styled from 'styled-components'
import { Button } from '@mui/material';
import { CustomButtonInterface } from '../../Models/Common/CustomViewsInterfaces';

type BtnColorTypes = { [K in ButtonType]: {
    type: K,
    background: string,
    textColor: string,
    hoverBackground: string,
    hoverTextColor: string,
    borderColor: string,
} };
const BtnColors: BtnColorTypes = {
    [ButtonType.PRIMARY]: {
        type: ButtonType.PRIMARY,
        background: "var(--textInfoColor) !important",
        textColor: "var(--cardBgPrimaryColor) !important",
        hoverBackground: "var(--buttonHoverBGPrimaryColor) !important",
        hoverTextColor: "var(--cardBgPrimaryColor) !important",
        borderColor: "transparent",
    },
    [ButtonType.PRIMARY_LIGHT]: {
        type: ButtonType.PRIMARY_LIGHT,
        background: "var(--fieldSwitchedCheckedBGSecondaryColor) !important",
        textColor: "var(--textInfoColor) !important",
        hoverBackground: "var(--textInfoColor) !important",
        hoverTextColor: "var(--cardBgPrimaryColor) !important",
        borderColor: "transparent",
    },
    [ButtonType.SUCCESS]: {
        type: ButtonType.SUCCESS,
        background: "var(--fieldSwitchedCheckedBGSuccessColor) !important",
        textColor: "var(--cardBgPrimaryColor) !important",
        hoverBackground: "var(--buttonHoverBGSuccessColor) !important",
        hoverTextColor: "var(--cardBgPrimaryColor) !important",
        borderColor: "transparent",
    },
    [ButtonType.SUCCESS_LIGHT]: {
        type: ButtonType.SUCCESS_LIGHT,
        background: "var(--buttonBGSuccessLightColor) !important",
        textColor: "var(--cardBgPrimaryColor) !important",
        hoverBackground: "var(--fieldSwitchedCheckedBGSuccessColor) !important",
        hoverTextColor: "var(--cardBgPrimaryColor) !important",
        borderColor: "transparent",
    },
    [ButtonType.SECONDARY]: {
        type: ButtonType.SECONDARY,
        background: "transparent",
        textColor: "var(--textInfoColor) !important",
        hoverBackground: "var(--fieldSwitchedCheckedBGSecondaryColor) !important",
        hoverTextColor: "var(--textInfoColor) !important",
        borderColor: "var(--textInfoColor) !important",
    },
    [ButtonType.DELETE]: {
        type: ButtonType.DELETE,
        background: "var(--fieldSwitchedCheckedBGDangerColor) !important",
        textColor: "white !important",
        hoverBackground: "var(--buttonHoverBGDangerColor) !important",
        hoverTextColor: "var(--cardBgPrimaryColor) !important",
        borderColor: "transparent",
    },
    [ButtonType.WARNING]: {
        type: ButtonType.WARNING,
        background: "var(--textWarningColor) !important",
        textColor: "white !important",
        hoverBackground: "var(--buttonHoverBGWarningColor) !important",
        hoverTextColor: "var(--cardBgPrimaryColor) !important",
        borderColor: "transparent",
    },
    [ButtonType.PREV_NEXT]: {
        type: ButtonType.PREV_NEXT,
        background: "var(--fieldSwitchedCheckedBGCancelColor) !important",
        textColor: "gray !important",
        hoverBackground: "gray !important",
        hoverTextColor: "white !important",
        borderColor: "transparent",
    },
    [ButtonType.WHITE]: {
        type: ButtonType.WHITE,
        background: "white !important",
        textColor: "var(--textInfoColor) !important",
        hoverBackground: "lightGray !important",
        hoverTextColor: "white !important",
        borderColor: "transparent",
    },
    [ButtonType.DELETE_LIGHT]: {
        type: ButtonType.DELETE_LIGHT,
        background: "transparent !important",
        textColor: "var(--fieldSwitchedCheckedBGDangerColor) !important",
        hoverBackground: "transparent !important",
        hoverTextColor: "var(--buttonHoverBGDangerColor) !important",
        borderColor: "transparent",
    },
    [ButtonType.CANCEL]: {
        type: ButtonType.CANCEL,
        background: "var(--fieldSwitchedCheckedBGCancelColor) !important",
        textColor: "var(--buttonIconCancelColor) !important",
        hoverBackground: "#767678 !important",
        hoverTextColor: "var(--cardBgPrimaryColor) !important",
        // borderColor: "var(--fieldSwitchedCheckedBGCancelColor) !important",
        borderColor: "transparent",
    },
    [ButtonType.CANCEL_LIGHT]: {
        type: ButtonType.CANCEL_LIGHT,
        background: "transparent !important",
        textColor: "var(--buttonIconCancelColor) !important",
        hoverBackground: "transparent !important",
        hoverTextColor: "#767678 !important",
        borderColor: "transparent !important",
    },
    [ButtonType.PRIMARY_NO_BG]: {
        type: ButtonType.PRIMARY_NO_BG,
        background: "transparent !important",
        textColor: "var(--textInfoColor) !important",
        hoverBackground: "transparent !important",
        hoverTextColor: "var(--buttonHoverBGPrimaryColor) !important",
        borderColor: "transparent",
    },
}

const StyledButton = styled(Button) <{ $btnType: ButtonType; $width?: string; $fullWidth?: boolean; $isDefault?: boolean; $isRoundedCorner?: boolean }>`
    height: 38px;
    min-height: 38px;
    width: ${(props) => props.$width ? props.$width : props.$fullWidth ? "100%" : "max-content"};
    border-radius: ${(props) => props.$isRoundedCorner ? "20px" : "4px"} !important;
    border: 1px solid ${props => BtnColors[props.$btnType].borderColor};
    background: ${(props) => (props.$isDefault ? "transparent" : BtnColors[props.$btnType].background)};
    color: ${(props) => (props.$isDefault ? BtnColors[props.$btnType].background : BtnColors[props.$btnType].textColor)};
    cursor: pointer;
    margin - top: 10px;
    padding: 0px 20px!important;
    box-shadow: ${(props) => props.$btnType == ButtonType.DELETE_LIGHT || props.$btnType == ButtonType.CANCEL_LIGHT || props.$btnType == ButtonType.PRIMARY_NO_BG ? "none" : "0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)"} !important;

    .MuiButton-icon.MuiButton-startIcon.MuiButton-iconSizeMedium,
        .MuiButton-icon.MuiButton-endIcon.MuiButton-iconSizeMedium {
            width: 15px;
            height: 15px;
            align-items: center;
        }

        &:hover {
            color: ${(props) => props.$isDefault ? 'gray !important' : BtnColors[props.$btnType].hoverTextColor};
            background: ${(props) => props.$isDefault ? 'var(--questionBackground) !important' : BtnColors[props.$btnType].hoverBackground};
        }

        &:disabled {
        cursor: not - allowed;
        background: "var(--fieldSwitchedCheckedBGCancelColor) !important";
        color: "var(--buttonIconCancelColor) !important";
}
`

const CustomButton = (fieldProps: CustomButtonInterface) => {
    const { ref, startIcon, endIcon, navigationLink, isDefault, btnType, fullWidth, width, isRoundedCorner, ...btnProps } = fieldProps;

    return <StyledButton {...btnProps}
        variant={isDefault ? 'text' : btnType == ButtonType.SECONDARY ? 'outlined' : 'contained'}
        ref={ref}
        startIcon={startIcon ?? null}
        endIcon={endIcon ?? null}
        href={navigationLink ?? null}
        $isDefault={isDefault}
        $btnType={btnType}
        $fullWidth={fullWidth}
        $width={width}
        $isRoundedCorner={isRoundedCorner}
        sx={{ textTransform: 'none' }}>
        {fieldProps.title}
    </StyledButton>
}

export default CustomButton;